@left-nav-width: 235px;

.show-left-nav {
  width: calc(100% - @left-nav-width);
  height: 100%;
  position: absolute;
}
